import Axios from "../../api/Axios";
const BASE_URL = "SGR/";
export const Endpoint = {
   
    GetQtrData: "SGRBrandDataView/GetQuarterSGR",
    GetTableData: "SGRBrandEligibility/PopulateBlankGrid"
};
export const createAPIEndpointSGRExcel = () => {
    return {get:(Endpoint)=>Axios.get(BASE_URL+Endpoint)};
};